import { appStore } from '../../app/AppStore';
import { selectContentFromAppState } from '../../app/selectors/ContentSelectors';
import { BackgroundJobStatus, BackgroundJobTaskType } from '../models/BackgroundJobInfo';
import { IExplorableItemTypeInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { CancelBackgroundJobRequest, ICancelBackgroundJobParams } from '../ServerApi/requests/CancelBackgroundJobRequest';
import { GetBackgroundJobsRequest, IGetBackgroundJobsResult } from '../ServerApi/requests/GetBackgroundJobsRequest';
import { BackgroundJobAllowedActions } from '../ServerApi/types/BackgroundJobAllowedActions';
import { IBackgroundJob } from '../ServerApi/types/IBackgroundJob';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { IActionResource, Resource } from './Resource';

export interface IBackgroundJobInfo extends IBackgroundJob, IExplorableItemTypeInfo<'backgroundJob'> {
}


export class BackgroundJobs extends Resource<IBackgroundJobInfo> implements IActionResource<BackgroundJobAllowedActions> {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory', '$q'];

  constructor(
    private ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory,
    private $q: ng.IQService,
    ) {
    super(FetcherFactory.getServerResourceFetcher(
      GetBackgroundJobsRequest,
      (result: IGetBackgroundJobsResult): IBackgroundJobInfo[] => result.backgroundJobs.map((j: IBackgroundJob) => {
        return {
          ...j,
          contentType: 'backgroundJob',
          id: j.jobId + '',
        } as IBackgroundJobInfo; // Typescript can't infer whether 'backgroundJobs' is a string or 'backgroundJobs'
      })
    ));
  }

  public actions(id: string): ng.IPromise<BackgroundJobAllowedActions> {
    const items = selectContentFromAppState(appStore.getState());
    const backgroundJob: IBackgroundJobInfo | undefined = items.find((item: IBackgroundJobInfo) => item.jobId + '' === id) as IBackgroundJobInfo;
    if (!backgroundJob) {
      throw new Error('Failed to find background job with id ' + backgroundJob.jobId);
    }
    const incomplete = backgroundJob.status === BackgroundJobStatus.Pending || backgroundJob.status === BackgroundJobStatus.InProgress;
    const isSystemJob = backgroundJob.taskType === BackgroundJobTaskType.System;
    const cancelBackgroundJob = incomplete && !isSystemJob;
    return this.$q.resolve({ cancelBackgroundJob });
  }

  public cancelBackgroundJob(cancelParms: ICancelBackgroundJobParams): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequestAndDelay(new CancelBackgroundJobRequest(cancelParms));
  }
}

Module.instance().service('BackgroundJobs', BackgroundJobs);
